var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',_vm._b({staticClass:"component-color-card",class:_vm.customClasses,style:(_vm.customStyle),attrs:{"flat":_vm.flat,"ripple":_vm.ripple,"light":_vm.isLight,"dark":!_vm.isLight}},'Card',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }